import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bdo-billing-consumption-tile',
    templateUrl: './billing-consumption-tile.component.html',
    styleUrls: ['./billing-consumption-tile.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BillingConsumptionTileComponent{
  @Input() accountId: string;

  constructor( ) {}

}
